import { useNavigate } from 'react-router-dom';

import { useAppSelector } from 'store';
import {
  selectCompany,
  selectHasRequiredShopifyPermissions,
  selectIsIntegratedWithShopify,
} from 'store/selectors/me/company';
import Announcement from 'storybookConfig/stories/cells/Announcement';
import { getShopifyAuthUrl, getShopifyStore } from 'utils/platform';

enum AnnouncementKind {
  None,
  Shopify,
}

export const useAnnouncementToDisplay = () => {
  const isIntegratedWithShopify = useAppSelector(selectIsIntegratedWithShopify);
  const hasRequiredShopifyPermissions = useAppSelector(selectHasRequiredShopifyPermissions);

  if (isIntegratedWithShopify && !hasRequiredShopifyPermissions) {
    return AnnouncementKind.Shopify;
  }

  return AnnouncementKind.None;
};

const ShopifyAnnouncement = () => {
  const navigate = useNavigate();
  const company = useAppSelector(selectCompany);

  const store = getShopifyStore(company);

  /* Without a store name there is no authorisation URL to open (it would be a blank tab). The
     Integrations settings say the store URL is missing and to contact support. */
  const connect = () => {
    if (store) {
      window.open(getShopifyAuthUrl(store), '_blank', 'noopener,noreferrer');
    } else {
      navigate('/settings/dropshipping/integrations');
    }
  };

  return (
    <Announcement
      kind="action"
      title="Action Required"
      ctaButtonText="Connect"
      onCtaButtonClick={connect}
    >
      You need to update your Shopify connection to continue syncing products and orders.
    </Announcement>
  );
};

const Announcements = () => {
  const announcementToDisplay = useAnnouncementToDisplay();

  switch (announcementToDisplay) {
    case AnnouncementKind.Shopify:
      return <ShopifyAnnouncement />;
    default:
      return null;
  }
};

export default Announcements;
